(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Ishi_slideshow"] && !Shopify.designMode) return;
  try {
    
jQuery(document).ready(function(){$('.ishislideshow-carousel').owlCarousel({nav:false,loop:true,autoplayTimeout:6000,autoplay:true,navText:["<i class='material-icons'></i>","<i class='material-icons'></i>"],items:1,itemsDesktop:false,itemsDesktopSmall:false,itemsTablet:false,itemsMobile:false});});

  } catch(e) { console.error(e); }
})();
})();
